import PropTypes from 'prop-types';

import rangeType from './range';
import regexType from './regex';

PropTypes.range = rangeType;
PropTypes.regex = regexType;

export default PropTypes;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/libs/props/index.js
// module id = 337
// module chunks = 0